module.exports = __webpack_public_path__ + "static/media/play-button.846eee2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/videoShare/components/images/play-button.png
// module id = 999
// module chunks = 0